if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.formInput = this.form?.querySelector('[name=id]');
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.cartType = this.cart?.dataset.cartType;

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector('body');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);

        // Flag to force opening the mobile size modal on next CTA after minicart closes
        this.forceSizeModal = false;
        window.addEventListener('minicart:closed', () => {
          this.forceSizeModal = true;
        });
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector('.wt__quick-buy--page-overlay');
        if (this.body.classList.contains('quick-buy-page-overlay')) this.body.classList.remove('quick-buy-page-overlay');
        if (complementaryOverlayPage.classList.contains('wt__quick-buy--page-overlay--open'))
          complementaryOverlayPage.classList.remove('wt__quick-buy--page-overlay--open');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Check for mobile size modal requirement
        if (this.shouldShowMobileSizeModal()) {
          this.openMobileSizeModal();
          return;
        }

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector('.loading-overlay__spinner');

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (loader) loader.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map(section => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              this.dispatchEvent(
                new CustomEvent('cart-drawer:refresh', {
                  detail: { response: response },
                  bubbles: true,
                  composed: true,
                })
              );

              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            // Open minicart overlay with contextual payload
            try {
              this.openMinicartFromResponse(response, formData);
            } catch (e) {
              // non-blocking
              console.warn('[product-form] minicart open failed', e);
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true }
              );
              if (this.cartType === 'drawer') quickAddModal.hide(true);
            } else {
              // If minicart exists, suppress drawer opening
              const forceNoDrawer = !!window.minicart;
              const isClosedCart = forceNoDrawer ? false : !document.body.classList.contains('page-overlay-cart-on');
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch(e => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.submitButton.removeAttribute('aria-disabled');
            if (this.error) {
              this.disableLoadingInButton();
              return;
            }
            this.quick_add_container = document.querySelector('.wt__quick-buy__container');
            this.quick_add_overlay = document.querySelector('.wt__quick-buy--page-overlay');
            this.quick_add_product = this.quick_add_container.querySelector('.wt-product');
            this.loader = this.quick_add_container.querySelector('.wt__quick-buy-loader');

            if (!this.quick_add_container.classList.contains('hidden')) {
              // use handle and quickbuy closeCart()

              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove('wt__quick-buy__container--open');
              this.quick_add_overlay.classList.remove('wt__quick-buy--page-overlay--open');
              document.body.classList.remove('quick-buy-page-overlay');
              this.loader.classList.remove('hidden');
            }

            // delay button loading
            setTimeout(() => {
              this.disableLoadingInButton();
            }, 200);
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains('template-cart');

        if (this.cartType === 'drawer' && isCartPage) {
          const overlay = document.querySelector('.wt__quick-buy--page-overlay');
          overlay.classList.remove('wt__quick-buy--page-overlay--open');
          body.classList.remove('quick-buy-page-overlay');
        } else if (this.cartType === 'drawer') {
          // If minicart is present, only refresh sections and do not open drawer
          const suppressDrawer = !!window.minicart;
          this.cart.renderContents(response, suppressDrawer ? false : isClosedCart);
          return;
        }
        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Mobile size modal helper methods
      shouldShowMobileSizeModal() {
        // Check if we're on mobile
        if (window.innerWidth >= 768) return false;

        // Check if this is a single U size product (set by Liquid)
        const submitButton = this.submitButton || this.querySelector('[type="submit"]');
        if (submitButton && submitButton.hasAttribute('data-single-u-size')) {
          // Single U size product - don't show modal, add directly to cart
          return false;
        }

        // Check if there are size options
        const sizeOptions = this.querySelectorAll(
          'input[name^="options"][value*="Size"], input[name^="options"][value*="Talla"], input[name^="options"][value*="size"], input[name^="options"][value*="talla"]'
        );
        if (sizeOptions.length === 0) return false;

        // If forced (after minicart closed), always show
        if (this.forceSizeModal) return true;

        // Check if no size is selected
        const selectedSize = Array.from(sizeOptions).find(option => option.checked);
        return !selectedSize;
      }

      openMobileSizeModal() {
        const modal = document.querySelector('.sheet-size');
        if (modal && modal.mobileSizeModal) {
          // Clear force flag once modal opens
          this.forceSizeModal = false;
          modal.mobileSizeModal.open();
        }
      }

      // Build and open minicart payload
      async openMinicartFromResponse(response, formData) {
        if (!window.minicart || typeof window.minicart.open !== 'function') return;
        // Variant recently added
        const variantId = Number(formData?.get('id'));
        const addedItem = Array.isArray(response?.items)
          ? (response.items.find(i => Number(i.id) === variantId) || response.items[response.items.length - 1])
          : null;

        // Locale and currency for formatting
        const locale = (document.documentElement.lang || 'es-ES').toLowerCase().includes('es') ? 'es-ES' : document.documentElement.lang || 'es-ES';
        const currency = response?.currency || (window.Shopify?.currency?.active) || 'EUR';

        // Title: "Talla <SIZE> añadida a la cesta" (robusto)
        const sizeFromOptions = addedItem?.options_with_values?.find(o => /size|talla/i.test(o?.name || ''))?.value;
        const ctaSpan = this.submitButton?.querySelector('span');
        const ctaText = ctaSpan?.textContent?.trim();
        const sizeFromCTA = (ctaText && /añadir\s+talla\s+(.+)$/i.test(ctaText))
          ? ctaText.match(/añadir\s+talla\s+(.+)$/i)[1].trim()
          : '';
        let sizeFromDOM = '';
        if (!sizeFromOptions) {
          const section = this.closest('section') || document;
          const wrappers = Array.from(section.querySelectorAll('.product-form__input'));
          for (const wrap of wrappers) {
            const name = wrap.dataset?.optionName || wrap.getAttribute('data-option-name') || '';
            if (window.OptionTypeUtils?.isSize(name)) {
              const selected = Array.from(wrap.querySelectorAll('input')).find(r => r.checked);
              sizeFromDOM = selected?.value?.trim() || wrap.querySelector('.wt-product__option__title .value')?.textContent?.trim() || '';
              break;
            }
          }
        }
        const selectedSize = sizeFromOptions || sizeFromDOM || sizeFromCTA;
        const computedTitle = selectedSize
          ? window.cartStrings.addedToCartSize.replace('__size__', selectedSize)
          : window.cartStrings.addedToCart;

        // Product title
        const productTitle = (addedItem?.product_title || document.querySelector('.brn-product__title')?.textContent || '').trim();

        // Image: prefer item.image; fallback featured; size for modal column
        const featuredImg = document.querySelector('.brn-product__featured__image');
        let imageSrc = addedItem?.image || featuredImg?.getAttribute('src') || '';
        if (imageSrc) {
          imageSrc = imageSrc.includes('?') ? `${imageSrc}&width=480` : `${imageSrc}?width=480`;
        }
        const imageAlt = addedItem?.product_title || featuredImg?.getAttribute('alt') || productTitle || '';

        // Price: prefer response item; robust fallback to /cart.js when sections-only response
        let priceCents = (addedItem?.final_price ?? addedItem?.price ?? 0);
        let priceText;
        if (!Number.isFinite(priceCents) || priceCents <= 0) {
          try {
            const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
            const fromCart = Array.isArray(cart?.items)
              ? cart.items.find(i => Number(i.id) === variantId) || cart.items[cart.items.length - 1]
              : null;
            if (fromCart) {
              // Shopify returns cents
              priceCents = Number(fromCart.final_price ?? fromCart.price ?? 0);
              // Update currency from cart if available
              if (cart?.currency) {
                // Some stores expose { currency: 'EUR' } in /cart.js
                // Use it when present to avoid mismatches

                const _curr = cart.currency;
                if (typeof _curr === 'string') {
                  // override only if different
                  // note: keep local variable name 'currency' defined above
                }
              }
            }
          } catch {
            // noop: keep 0 if fetch fails; UI will show empty priceText below
          }
        }
        if (Number.isFinite(priceCents) && priceCents > 0) {
          priceText = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(priceCents / 100);
        } else {
          // Avoid misleading "0,00 €"; leave empty until cart drawer refresh
          priceText = '';
        }

        // Variant text: COLOR (prefer response options; fallback to DOM selection; then variant title)
        const colorFromOptions = addedItem?.options_with_values?.find(o => window.OptionTypeUtils?.isColor(o?.name))?.value;
        let variantText = colorFromOptions || '';

        // Fallback: read from product form DOM option with name "Color"
        if (!variantText) {
          const section = this.closest('section') || document;
          const wrappers = Array.from(section.querySelectorAll('.product-form__input'));
          for (const wrap of wrappers) {
            const name = wrap.dataset?.optionName || wrap.getAttribute('data-option-name') || '';
            if (window.OptionTypeUtils?.isColor(name)) {
              const selected = Array.from(wrap.querySelectorAll('input')).find(r => r.checked);
              variantText = selected?.value?.trim() || wrap.querySelector('.wt-product__option__title .value')?.textContent?.trim() || '';
              break;
            }
          }
        }

        // Final fallback: infer from variant title, first segment
        if (!variantText && addedItem?.variant_title) {
          variantText = (addedItem.variant_title.split(' / ')[0] || '').trim();
        }

        // Normalize to uppercase to match UI example
        variantText = (variantText || '').toUpperCase();

        // Item count: prefer response.item_count; fallback parse sections
        // Robust item count: prefer sections, avoid defaulting to 0
        let itemCount;
        try {
          const sections = response?.sections || {};
          if (sections['cart-icon-bubble']) {
            const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            const bubble = doc.querySelector('.wt-header__panel__counter');
            const parsed = Number(bubble?.textContent?.trim());
            if (Number.isFinite(parsed)) itemCount = parsed;
          } else if (sections['cart-drawer']) {
            const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            const titleEl = doc.querySelector('#CartDrawer-TotalQty');
            if (titleEl) {
              const m = titleEl.textContent.match(/\((\d+)\)/);
              const parsed = m ? Number(m[1]) : undefined;
              if (Number.isFinite(parsed)) itemCount = parsed;
            }
          }
        } catch { /* noop */ }

        window.minicart.setInvoker?.(this.submitButton);
        window.minicart.open({
          title: computedTitle,
          productTitle,
          imageSrc,
          imageAlt,
          priceText,
          variantText,
          itemCount,
        });
      }
    }
  );
}
